module.exports = __webpack_public_path__ + "static/media/rexel_logo.3e3b8415.png";